@let user = this.user();

<lib-user-profile
    title="{{ user?.first_name || user?.name || '' | shortenName: user?.last_name?.[0] }}"
    [backButtonUrl]="backButtonUrl() || backDefaultHref"
    [avatarImage]="user?.photo_url"
    [cards]="[
        {
            type: 'rating',
            value: user?.star_rating
        },
        {
            type: 'posted_jobs',
            value: user?.posted_jobs_count
        }
    ]">
    @if (!user?.star_rating && !user?.posted_jobs_count) {
        <div ngProjectAs="top-content" class="ion-margin-top">
            <lib-card>
                <p class="text-center" [style.--paragraph-color]="'var(--ion-color-dark-80)'">
                    <span class="font-weight-medium">
                        This client is new here, so they don't have a rating or any posted work yet.
                    </span>
                </p>
            </lib-card>
        </div>
    }

    <lib-review-item [starRating]="user?.star_rating || 0" [reviews]="user?.reviews || []" />
</lib-user-profile>
